import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {retry, catchError, tap} from 'rxjs/operators';
import {Route, Router, ActivatedRoute, NavigationExtras} from '@angular/router';
import {SharedService} from '../shared/shared.service';
import {COMMONTEXT} from '../../app.constants';
import {UsersService} from '../../services/users/users.service';
import {environment} from 'src/environments/environment';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private sharedService: SharedService,
        private usersService: UsersService
    ) {
    }

    logout = false;
    unauthorized = false;
    popupOpened = false;
    unAuthpopupOpened = false;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log('REQ ', req);
        let docupload = environment.baseUrl + 'api/lms/uploadContent';
        let urlExist = req.url.includes(docupload);
        // console.log('urlExist ', urlExist);
        // if (req.headers.get("skip"))
        //     return next.handle(req);
        if (urlExist == false) {
            this.sharedService.showLoader();
        }

        const started = Date.now();
        return next.handle(req).pipe(
            tap(event => {

                if (event instanceof HttpResponse) {
                    this.sharedService.hideLoader();
                } else {
                }
            }, error => {
                this.sharedService.hideLoader();
                // this.sharedService.showError(JSON.stringify(error.status))
                console.error('NICE ERROR' + JSON.stringify(error));
                if (error.status == 500) {
                    this.sharedService.showError('Something went wrong. Please try after some time');
                } else if (error.status == 409) {
                    this.logout = true;
                    // this.sharedService.confirm(COMMONTEXT.CONFIRMATION_HEADER, 'User login from different browser', 'md').then((res: any) => {
                    //   this.router.navigateByUrl('/Login');
                    // })
                } else if (error.status == 401) {
                    this.unauthorized = true;
                }
                if (this.logout == true) {
                    // As per discussion removed API hit for Logout
                    this.router.navigateByUrl('/Login');
                    // this.popupOpened = true;
                    // if (this.router.url != '/Login') {
                    //   this.usersService.logout().then((resp: any) => {
                    //     this.router.navigateByUrl('/Login');
                    //   }, (error) => {
                    //     this.router.navigateByUrl('/Login')
                    //   })
                    // }

                    // this.sharedService.confirm(COMMONTEXT.CONFIRMATION_HEADER, COMMONTEXT.CONCURRENT_LOGIN, 'md').then((res: any) => {
                    //   this.usersService.logout().then((resp: any) => {
                    //       this.router.navigateByUrl('/Login');
                    //   }, (error) => {
                    //     this.router.navigateByUrl('/Login')
                    //    })
                    // })
                }

                if (this.unauthorized == true) {
                    this.unAuthpopupOpened = true;
                    this.router.navigateByUrl('/Login');
                    // if (this.router.url != '/Login') {
                    //   this.usersService.logout().then((resp: any) => {
                    //     this.router.navigateByUrl('/Login');
                    //   }, (error) => {
                    //     this.router.navigateByUrl('/Login')
                    //   })
                    // }

                    // this.usersService.logout().then((resp: any) => {
                    //   this.router.navigateByUrl('/Login');
                    //  }, (error) => {
                    //   this.router.navigateByUrl('/Login');
                    //  })
                    // this.sharedService.confirm(COMMONTEXT.CONFIRMATION_HEADER, COMMONTEXT.UN_AUTH , 'md').then((res: any) => {
                    //    this.usersService.logout().then((resp: any) => {
                    //     this.router.navigateByUrl('/Login');
                    //    }, (error) => {
                    //     this.router.navigateByUrl('/Login');
                    //    })
                    // })
                }
            })
        );
    }
}
